"use strict";
import Vue     from 'vue/dist/vue.common.js';
import Popper  from '../components/popper';

const VerifiedResultListingItem = Vue.component('ts-vr-listing-item', {
  props: {
    item: {
      required: true,
      type: Object
    }
  },

  template: `
  <li class="RelatedResourcesStrata-item">
    <div class="VerifiedResultListingItem">
      <div class="VerifiedResultListingItem-content">
        <div class="VerifiedResultListingItem-meta">
          <ul class="VerifiedResultListingItem-meta-list">
            <li class="VerifiedResultListingItem-meta-item VerifiedResultListingItem-meta-item--block"
            v-if="item.table.verified_results">
              <p class="VerifiedResultListingItem-meta-label">Commitment Element</p>
              <p class="VerifiedResultListingItem-meta-text">{{ item.table.description }}</p>
            </li>
            <li class="VerifiedResultListingItem-meta-item VerifiedResultListingItem-meta-item--block"
            v-if="item.table.verified_results">
              <p class="VerifiedResultListingItem-meta-label">Progress To Date</p>
                <p class="VerifiedResultListingItem-meta-text">
                  {{ item.table.verified_results }}
                  <ts-popper
                  v-if="item.table.tooltip_link"
                  :content="item.table.tooltip_content"
                  class="tooltip-button">
                    {{ item.table.tooltip_link }}
                    <svg class="tooltip-button-icon Icon Icon--currentColor Icon--inline" version="1.1" xmlns="http://www.w3.org/2000/svg" width="10" height="28" viewBox="0 0 10 28">
                      <title>info</title>
                      <path d="M10 21v2c0 0.547-0.453 1-1 1h-8c-0.547 0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h1v-6h-1c-0.547 0-1-0.453-1-1v-2c0-0.547 0.453-1 1-1h6c0.547 0 1 0.453 1 1v9h1c0.547 0 1 0.453 1 1zM8 3v3c0 0.547-0.453 1-1 1h-4c-0.547 0-1-0.453-1-1v-3c0-0.547 0.453-1 1-1h4c0.547 0 1 0.453 1 1z"></path>
                    </svg>
                  </ts-popper>
                </p>
            </li>
            <li class="VerifiedResultListingItem-meta-item"
            v-if="item.table.compliance_date">
              <p class="VerifiedResultListingItem-meta-label">Implementation Date</p>
              <p class="VerifiedResultListingItem-meta-text">{{ item.table.compliance_date }}</p>
            </li>
            <li class="VerifiedResultListingItem-meta-item"
            v-if="item.table.deadline_date">
              <p class="VerifiedResultListingItem-meta-label">Reporting Date</p>
              <p class="VerifiedResultListingItem-meta-text">{{ item.table.deadline_date }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
  `
})